export default __webpack_public_path__ + "f6d0d7696b0c136b9c920c064bfe5710.ttf";